import React from 'react';
import { createOfferCurrency as currency } from '../../utils/format';

import NonUnionTable from './RateScaleRow/NonUnionTable';
import UnionTable from './RateScaleRow/UnionTable';

import ExpandableTableCell from 'common/oldJavascripts/components/Base/ExpandableTable/ExpandableTableCell';
import ExpandableTableRow from 'common/oldJavascripts/components/Base/ExpandableTable/ExpandableTableRow';
import ExpandableTableRowHeader from 'common/oldJavascripts/components/Base/ExpandableTable/ExpandableTableRowHeader';
import ExpandableTableRowInfo from 'common/oldJavascripts/components/Base/ExpandableTable/ExpandableTableRowInfo';
import NonUnionRateTable from 'studio/components/OfferPage/TermsOfEmployment/NonUnionRateTable';
import useFeatureFlags from 'common/hooks/useFeatureFlags';
import isNonUnionWorkScheduleA from 'common/utilities/isNonUnionWorkScheduleA';

const NON_UNION_EXEMPT_TABLE_HEADER = [
  'Daily Rate',
  'Weekly Rate',
  'Number of Days',
];
const NON_UNION_HOURLY_TABLE_HEADER = [
  'Hourly Rate',
  'Overtime Rate',
  'Guaranteed Hours',
];

const RateScaleRow = props => {
  const { offer, colSpan } = props;
  const {
    terms_of_employment: terms = {},
    work_schedule_code: workScheduleCode,
  } = offer;
  const isUnion = !offer?.union_is_non_union;
  const flags = useFeatureFlags();
  const isNonUnionScheduleFlagActiveA = flags.includes('nonUnionSchedules');
  const isNonUnionScheduleFlagActiveC = flags.includes('nonUnionScheduleC');
  const isNonUnionScheduleA =
    isNonUnionScheduleFlagActiveA && isNonUnionWorkScheduleA(workScheduleCode);
  const isNonUnionScheduleC =
    isNonUnionScheduleFlagActiveC &&
    ['C', 'E', 'CN'].includes(workScheduleCode);
  const isNonUnionV2Active = isNonUnionScheduleA || isNonUnionScheduleC;

  const rateMultiplication = payRate => {
    if (!payRate) return 0;
    return Number((payRate / terms?.rate_per_week_studio).toFixed(1));
  };
  const renderRateTable = () => {
    if (isUnion) {
      return <UnionTable offer={terms} />;
    }
    const { data, header } = getNonUnionTableInfo();
    const employmentTermsData = {
      rate: terms?.rate_per_week_studio,
      sixthDayPayMultiplication: rateMultiplication(terms?.pay_6th_day_rate),
      seventhDayPayMultiplication: rateMultiplication(terms?.pay_7th_day_rate),
      overtimeRatePerHour: terms?.overtime_rate,
      ratePerHour: terms?.rate_per_hour_studio,
      guaranteedHours: terms?.guaranteed_hours_studio,
      guaranteedHours6thDay: terms?.pay_6th_day_rate,
      guaranteedHours7thDay: terms?.pay_7th_day_rate,
    };

    return isNonUnionV2Active ? (
      <NonUnionRateTable
        isReadOnly
        onChange={() => {}}
        formData={employmentTermsData}
        workScheduleCode={workScheduleCode}
      />
    ) : (
      <NonUnionTable tableHeader={header} tableData={data} offer={offer} />
    );
  };
  const getNonUnionTableInfo = () => {
    const { terms_of_employment } = offer;
    const {
      rate_per_day_studio: ratePerDayStudio,
      rate_per_week_studio: ratePerWeekStudio,
      guaranteed_days_studio: guaranteedDaysStudio,
      rate_per_hour_studio: ratePerHourStudio,
      overtime_rate: overtimeRate,
      guaranteed_hours_studio: guaranteedHoursStudio,
    } = terms_of_employment;
    if (ratePerDayStudio || ratePerWeekStudio || guaranteedDaysStudio) {
      return {
        data: [
          'Non-Union',
          currency(ratePerDayStudio),
          currency(ratePerWeekStudio),
          guaranteedDaysStudio,
        ],
        header: NON_UNION_EXEMPT_TABLE_HEADER,
      };
    }
    return {
      data: [
        'Non-Union Hourly',
        currency(ratePerHourStudio),
        currency(overtimeRate),
        guaranteedHoursStudio,
      ],
      header: NON_UNION_HOURLY_TABLE_HEADER,
    };
  };

  return (
    <ExpandableTableRow
      rowExpanded
      data-test-id={`RateScaleRow-root-${offer.id}`}
    >
      <ExpandableTableCell colSpan={colSpan} expanded>
        <ExpandableTableRowHeader>Rate/Scale</ExpandableTableRowHeader>
        <ExpandableTableRowInfo>{renderRateTable()}</ExpandableTableRowInfo>
      </ExpandableTableCell>
    </ExpandableTableRow>
  );
};

export default RateScaleRow;
